import Vue from 'vue';
import { BfDatepicker } from 'src/components/Butterfly';
import dayjs from 'dayjs';
export default Vue.extend({
    components: {
        BfDatepicker,
    },
    props: {
        /** which item is selected  */
        selected: {
            type: [Number, String, Date],
            required: true,
        },
        /** list of items, { value: Number|String|Date, label: String, disabled: boolean}  */
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dateFormat: 'DD/MM/YYYY',
        };
    },
    methods: {
        dateRangeConfig(item) {
            return {
                minDate: dayjs(item.inputValue[0], this.dateFormat).toDate(),
                maxDate: dayjs(item.inputValue[1], this.dateFormat).toDate(),
            };
        },
        updateInput(item, val, index) {
            if (item.input === 'daterange') {
                item.onChange?.(val);
                // Auto-select next input
                if (index === 0 && !item.inputValue[1]) {
                    this.$nextTick(() => {
                        const input = document.querySelector('.daterange-input input:nth-of-type(2)');
                        input && input.click();
                    });
                }
            }
        },
        change({ value, disabled, input, inputValue }, e) {
            e.preventDefault();
            e.stopPropagation();
            if (!disabled && value !== this.selected) {
                /**  value property of item clicked on
                  * @event change
                  * @type {Number, String, Date}
                */
                const dismiss = input !== 'daterange';
                this.$emit('change', value, dismiss);
                // Auto-select first input
                if (input === 'daterange' && !inputValue[0]) {
                    this.$nextTick(() => {
                        const input = document.querySelector('.daterange-input input');
                        input && input.click();
                    });
                }
            }
        }
    }
});
